import { createReducer } from '@reduxjs/toolkit';

import { setHomeActiveTab } from './actions';
import { HomeTabs } from './types';

export interface HomeState {
  activeTab: HomeTabs;
}

const initialState: HomeState = {
  activeTab: HomeTabs.ONGOING_COURSES,
};

const homeReducer = createReducer(initialState, (builder) => {
  builder.addCase(setHomeActiveTab, (state, action) => {
    state.activeTab = action.payload.tab;
  });
});

export default homeReducer;
